/// ///////////////////////////////////////////////////////////////
/// ///////////////////////////////////////////////////////////////
/// ///////////////////////// SPANISH /////////////////////////////
/// ///////////////////////////////////////////////////////////////
/// ///////////////////////////////////////////////////////////////

export const data = {
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Bienvenido",
    Main_Nav_HelpfulLinks: "Vínculos útiles",
    Main_Nav_LogOut: "CERRAR SESIÓN",
    Main_Nav_HelpfulLinks_LI_s1: "Contactar el enfermero de mi estudiante",
    Main_Nav_HelpfulLinks_LI_s2: "Calendarios Académicos",
    Main_Nav_HelpfulLinks_LI_s3: "Recursos para padres",
    Main_Nav_HelpfulLinks_LI_s4: "Rutas de autobuses",
    Main_Nav_HelpfulLinks_LI_s5: "Pagos en línea",
    Main_Nav_HelpfulLinks_LI_s6: "Menus de almuerzo",
    Main_Nav_Exit: "SALIR",
    Main_Nav_Tagline: "Aprende hoy. Lidera mañana.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Agregar",
    Global_Close: "Cerrar",
    Global_Completed: "Completado",
    Global_InProgress: "En Progreso",
    Global_GoTo: "Ir a",
    Global_MoreInfo: "Más información",
    Global_NotStarted: "No Iniciado",
    Global_Open: "Abrir",
    Global_OpenFrom: "Abrir desde", // <some date> - <some date>
    Global_Status: "Estado",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Transparencia Financiera de DCSD",
    Breadcrumb_Translations: "Las traducciones son experimentales",
    /// /////////////////////////////////////////////////////////
    /// //////////////// Main ///////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Instruction: (
        <ul>
            <li>
                Esta herramienta permite al público buscar y exportar información sobre los gastos financieros del DCSD
                a partir del 1 de julio de 2017.
            </li>
            <li>
                Vea un{" "}
                <a
                    href="https://www.dcsdk12.org/about/departments/business-services/budget-and-accounting"
                    rel="noreferrer"
                    target="_blank"
                >
                    Plan de Cuentas
                </a>{" "}
                aplicable a las transacciones de DCSD en la sección &ldquo;Recursos&rdquo;.
            </li>
            <li>
                Por favor, considere el contexto al evaluar las transacciones financieras. Agradecemos sus preguntas
                sobre nuestras transacciones o registros financieros.
            </li>
        </ul>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////// Faceted Search //////////////////////////
    /// /////////////////////////////////////////////////////////
    Facet_Keyword: "Introduzca Palabra Clave Aquí",
    Facet_Export: "Exportar CSV",
    Facet_Search: "Buscar",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Forms /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Fiscal_Year: "Año Fiscal",
    Fiscal_Year_Instruction: (
        <h5>
            ¿Qué <b>año fiscal</b> le gustaría ver?
        </h5>
    ),
    Quarter_Instruction: (
        <>
            <h5>
                ¿Qué <b>trimestre</b> le gustaría ver?
            </h5>
            <p>
                Seleccione uno de los trimestres del año fiscal disponibles para generar un conjunto de resultados
                inicial. No se pueden seleccionar trimestres futuros.
            </p>
        </>
    ),
    Quarter_View: "Ver",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Results ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    Results_Title: "Resultados de búsqueda",
    Results_Instruction:
        'A continuación se enumeran los resultados de la búsqueda. Los resultados de la búsqueda se pueden refinar aún más por Fondo, Ubicación, Tipo de Pago y Categoría de Gasto. Los usuarios también pueden utilizar la búsqueda por palabra clave para ayudar a encontrar información específica sobre gastos dentro de los resultados filtrados. Los resultados de la búsqueda se pueden exportar (formato .csv) haciendo clic en el botón "Exportar CSV".',
    Results_No_Results: "No Se Encontraron Pagos"
};
